import { lazy } from 'react';

// Code-split the run screen: it pulls in react-markdown (+ remark-gfm, rehype-sanitize)
// and anser, which dashboard/list-only users never load. Kept in its own module so
// routes.tsx stays a non-component config file (react-refresh/only-export-components).
// `.then` adapts RunPage's named export to the default React.lazy expects.
export const RunPage = lazy(() => import('./RunPage').then((m) => ({ default: m.RunPage })));
